import { useEffect, useState, type FC } from "react";
import { motion } from "motion/react";

interface ShakeProps {
  src: string;
  alt: string;
  className?: string;
  intensity?: number;
}

export const Shake: FC<ShakeProps> = ({
  src,
  alt,
  className = "",
  intensity = 2,
}) => {
  const [key, setKey] = useState(0);

  const generateShakeValues = () => {
    const amp = intensity * 1.3;

    return {
      x: [
        0,
        -amp * (0.6 + Math.random() * 0.8),
        amp * (0.5 + Math.random() * 0.9),
        -amp * (0.7 + Math.random() * 0.6),
        amp * (0.4 + Math.random() * 0.8),
        -amp * (0.3 + Math.random() * 0.7),
        0,
      ],
      y: [
        0,
        -amp * (0.3 + Math.random() * 0.5),
        amp * (0.4 + Math.random() * 0.6),
        -amp * (0.2 + Math.random() * 0.5),
        amp * (0.3 + Math.random() * 0.4),
        -amp * 0.2,
        0,
      ],
      rotate: [
        0,
        -amp * (0.4 + Math.random() * 0.6),
        amp * (0.3 + Math.random() * 0.5),
        -amp * (0.5 + Math.random() * 0.4),
        amp * (0.2 + Math.random() * 0.6),
        -amp * 0.3,
        0,
      ],
      scale: [
        1,
        1 + Math.random() * 0.025,
        1 - Math.random() * 0.015,
        1 + Math.random() * 0.02,
        1,
      ],
    };
  };

  const shakeValues = generateShakeValues();

  useEffect(() => {
    const interval = setInterval(
      () => {
        setKey((prev) => prev + 1);
      },
      2200 + Math.random() * 800,
    );

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.img
      key={key}
      src={src}
      alt={alt}
      className={className}
      animate={shakeValues}
      transition={{
        duration: 0.55 + Math.random() * 0.15,
        ease: "easeInOut",
      }}
    />
  );
};
